(() => {
  const cache = new Map();
  function requestProducts(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) return Promise.reject(new Error('Menu origin'));
    url.search = '';
    url.searchParams.set('view', 'dh-menu-products');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    if (cache.has(url.href)) return cache.get(url.href);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const pending = fetch(url.href, { credentials: 'same-origin', signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error('Menu response');
        return response.text();
      })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.querySelector('[data-dh-menu-fragment]');
        if (!fragment) throw new Error('Menu fragment');
        return Array.from(fragment.querySelectorAll('[data-dh-menu-product]'));
      })
      .catch(error => { cache.delete(url.href); throw error; })
      .finally(() => clearTimeout(timeout));
    if (cache.size >= 24) cache.delete(cache.keys().next().value);
    cache.set(url.href, pending);
    return pending;
  }
  function hydrate(root) {
    if (!root) return;
    const marker = root.querySelector('template[data-dh-menu-url]');
    if (!marker || marker.dataset.loading || Number(marker.dataset.retryAfter || 0) > Date.now()) return;
    marker.dataset.loading = 'true';
    const parent = marker.parentElement;
    const mobile = marker.dataset.menuMode === 'mobile';
    parent.setAttribute('aria-busy', 'true');
    requestProducts(marker.dataset.dhMenuUrl).then(cards => {
      if (!marker.isConnected) return;
      const fragment = document.createDocumentFragment();
      cards.slice(0, mobile ? 6 : 10).forEach(source => {
        const card = source.cloneNode(true);
        card.className = mobile ? 'mnav2__pc' : 'mega__card';
        const image = card.querySelector('img');
        if (image) image.sizes = mobile ? '54px' : '130px';
        fragment.appendChild(card);
      });
      parent.insertBefore(fragment, marker);
      marker.remove();
    }).catch(() => { marker.dataset.retryAfter = String(Date.now() + 15000); })
      .finally(() => { delete marker.dataset.loading; parent.removeAttribute('aria-busy'); });
  }
  function activePanel(item, target) {
    const tab = target && target.closest('.mega__cat');
    if (tab) {
      return Array.from(item.querySelectorAll('[data-mega-panel]'))
        .find(panel => panel.dataset.megaPanel === tab.dataset.megaTab);
    }
    return item.querySelector('.mega__panel.is-active');
  }
  window.__dhHydrateMenu = root => {
    if (root && root.matches('.site-nav__item.has-mega')) hydrate(activePanel(root));
    else hydrate(root);
  };
  const nav = document.querySelector('.site-nav');
  if (nav) {
    const onIntent = event => {
      const item = event.target.closest('.site-nav__item.has-mega');
      if (item) hydrate(activePanel(item, event.target));
    };
    nav.addEventListener('pointerover', onIntent, { passive: true });
    nav.addEventListener('focusin', onIntent);
    const hovered = nav.querySelector('.has-mega:hover, .has-mega:focus-within');
    if (hovered) hydrate(activePanel(hovered));
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-acc2]');
    if (button) hydrate(button.closest('.mnav2__sub'));
  }, true);
})();
